import { logError } from '@libs/focus-frontend-services/src/LoggingService/LoggingService';

import { loadStyle, loadScript } from './helpers';

const loadEnhancement = (domain, name, domainManifest, props) => {
  const { scripts, styles } = domainManifest.apps[name];
  const { translations } = domainManifest;

  const isRegistered = window.top.services.microApps.isRegistered(domain, name);

  const parsedProps = props ? JSON.parse(props) : {};

  if (isRegistered) {
    window.top.services.microApps.mount(domain, name, { translations, ...parsedProps });
  } else {
    Promise.all([
      ...styles.map((style) => loadStyle(style, domain)),
      ...scripts.map((script) => loadScript(script, domain)),
    ])
      .then(() => {
        window.top.services.microApps.mount(domain, name, { translations, ...parsedProps });
      })
      .catch((error) => {
        logError(error);
      });
  }
};

window.addEventListener('TL.MicroServices.loadEnhancement', ({ detail: { app, enhancement, props } }) => {
  window.top.services.manifest.getManifest().then((manifest) => {
    const domainManifest = manifest[app];

    const unmountListener = () => {
      if (!enhancement) {
        return;
      }

      try {
        window.top.services.microApps.unmount(app, enhancement);
      } catch (exception) {
        // make sure the listeners are removed, and throw the exception
        document.removeEventListener('routing.page_load', unmountListener);
        window.removeEventListener('TL.Core.loadMicroService', unmountListener);
        throw exception;
      }

      document.removeEventListener('routing.page_load', unmountListener);
      window.removeEventListener('TL.Core.loadMicroService', unmountListener);
    };

    document.addEventListener('routing.page_load', unmountListener);
    window.addEventListener('TL.Core.loadMicroService', unmountListener);

    loadEnhancement(app, enhancement, domainManifest, props);
  });
});
